module.exports = __webpack_public_path__ + "static/media/robot.7dc0c6bd.png";